import React from 'react';
import { StyledTextarea } from './styles/MultilineInput.styles';
import { ObjectWrapper } from './styles/Common.styles';

const MultilineInputControl = ({ control, renderMode }) => (
  <ObjectWrapper>
    <StyledTextarea
      styleProps={control.attributes}
      defaultValue={control.defaultValue}
      placeholder={control.placeholder}
      maxLength={control.maxLength}
      renderMode={renderMode}
      readOnly
    />
  </ObjectWrapper>
);

export default MultilineInputControl;